module.exports = __webpack_public_path__ + "static/media/slide4.797cc649.svg";